import { ShieldCheck, Mail, ShoppingBag } from "lucide-react";
import { CONTACT_EMAIL, SITE_DOMAIN } from "@/data/characters";

export const Footer = () => (
  <footer data-testid="footer" className="mt-16 bg-[#0b4fa3] text-white">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-8 md:grid-cols-[1.2fr_1fr_1fr]">
      <div>
        <p className="font-display text-3xl font-bold">Handy & Friends</p>
        <p className="mt-2 font-display text-lg text-sky-200">It's Good to Have Clean Hands!</p>
        <p data-testid="footer-domain" className="mt-4 font-display text-base font-semibold text-white">{SITE_DOMAIN}</p>
      </div>
      <div data-testid="footer-privacy-note" className="flex gap-3">
        <ShieldCheck className="mt-1 h-6 w-6 shrink-0 text-sky-200" />
        <p className="text-sm leading-relaxed text-sky-50">
          <span className="font-bold">A safe space for little ones.</span> We don't collect any personal information from children. No sign-ups, no tracking forms, just clean-hands fun.
        </p>
      </div>
      <div className="space-y-4 text-sm">
        <a data-testid="footer-contact-email" href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-3 text-sky-50 transition-colors hover:text-white">
          <Mail className="h-5 w-5 text-sky-200" />
          <span>Parents & organisations: {CONTACT_EMAIL}</span>
        </a>
        <p data-testid="footer-bring-handy-home" className="flex items-center gap-3 text-sky-50">
          <ShoppingBag className="h-5 w-5 text-sky-200" />
          <span>Bring Handy Home — coming soon</span>
        </p>
      </div>
    </div>
    <p className="border-t border-white/10 py-5 text-center text-xs text-sky-200">© {new Date().getFullYear()} {SITE_DOMAIN} · Handy™, Soapy™, Splashy™ and Germy™ are trademarks of Handy & Friends.</p>
  </footer>
);
